export enum StackFields {
    NAME = 'name',
    COLOR = 'color',
    OWNER = 'owner',
    MEMBERS = 'members',
    ITEMS = 'items',
    CLOSED_AT = 'closedAt',
}
